import { connect } from "react-redux";

import { Actions as PAYROLL_ACTIONS } from "@/redux/actions/payrollActions";
import { CheckBadgeIcon, ExclamationTriangleIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { useState } from "react";
import Select from "react-select";
import Modal from "@/common/Modal";

const lateReasonOptions = [
	{
		value: "A",
		label: "A - Notional payment: Payment to Expat by third party or overseas employer",
	},
	{
		value: "B",
		label: "B - Notional payment: Employment related security",
	},
	{
		value: "C",
		label: "C - Notional payment: Other",
	},
	{
		value: "D",
		label: "D - Payment subject to Class 1 NICs but P11D/P9D for tax",
	},
	{
		value: "F",
		label: "F - No requirement to maintain a Deductions Working Sheet or Impractical to report work done on the day",
	},
	{
		value: "G",
		label: "G - Reasonable excuse",
	},
	{
		value: "H",
		label: "H - Correction to earlier submission",
	},
];

const LateSubmitModal = ({ isOpen, closeModal, payPeriodDetails, updatePayPeriod }) => {
	const [lateReason, setLateReason] = useState("A");

	const handleSubmit = () => {
		const data = {
			...payPeriodDetails,
			lateReason,
		};

		updatePayPeriod(data);
		closeModal();
	};

	return (
		<Modal
			status={isOpen}
			close={closeModal}
			title="Late Submission"
			color="bg-warning"
		>
			<div className="block-content p-10">
				<div
					className="col-xs-12 p-0"
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<ExclamationTriangleIcon
						style={{
							color: "#ffc107",
							height: "12em",
						}}
					/>
				</div>
				<div className="text-center mb-5">
					<h4>
						<div>Payroll is being submitted after pay date, a late reason must be provided!</div>
					</h4>
				</div>
				<div
					className="col-sm-12"
					style={{
						paddingBottom: 10,
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<div className="col-xs-12">
						<Select
							options={lateReasonOptions}
							value={lateReasonOptions.find((option) => option.value === lateReason)}
							onChange={(e) => setLateReason(e.value)}
						/>
					</div>
				</div>
				<div
					className="col-sm-12"
					style={{
						paddingBottom: 10,
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						gap: 10,
					}}
				>
					<div
						className="btn btn-success"
						onClick={handleSubmit}
					>
						<CheckBadgeIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
						<span style={{ float: "left" }}>Submit</span>
					</div>
					<div
						className="btn btn-danger"
						style={{ marginRight: 5 }}
						onClick={() => {
							closeModal();
						}}
					>
						Cancel
					</div>
				</div>
			</div>
		</Modal>
	);
};

const mapStateToProps = (state) => {
	return {
		isOpen: state.payroll?.lateSubmitModal?.open,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		closeModal: () => dispatch(PAYROLL_ACTIONS.setLateSubmitModal(false)),
		updatePayPeriod: (data) => dispatch(PAYROLL_ACTIONS.payrollUpdatePayPeriod(data)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(LateSubmitModal);
